import React, { useState } from 'react';
import { candidateAPI } from '../../services/api';
import './ResumeUpload.css';

const ResumeUpload = ({ onUploadSuccess }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const ext = selectedFile.name.split('.').pop().toLowerCase();
      if (!['pdf', 'doc', 'docx'].includes(ext)) {
        setError('Please upload a PDF, DOC, or DOCX file');
        return;
      }
      setFile(selectedFile);
      setError('');
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file');
      return;
    }

    setUploading(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('file', file);

      await candidateAPI.uploadResume(formData);
      
      if (onUploadSuccess) {
        onUploadSuccess();
      }
      
      setFile(null);
      alert('Resume uploaded successfully!');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error uploading resume');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="resume-upload">
      <div className="upload-area">
        <input
          type="file"
          id="resume-file"
          accept=".pdf,.doc,.docx"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
        <label htmlFor="resume-file" className="upload-label">
          {file ? file.name : 'Choose Resume File (PDF, DOC, DOCX)'}
        </label>
      </div>
      
      {file && (
        <button
          className="btn btn-primary"
          onClick={handleUpload}
          disabled={uploading}
        >
          {uploading ? 'Uploading...' : 'Upload Resume'}
        </button>
      )}
      
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default ResumeUpload;

